import React, { forwardRef, HTMLAttributes } from 'react'
import { Icon } from './Icon'
import { Button } from './Button'

interface Props extends HTMLAttributes<HTMLButtonElement> {
    onClick?: () => void
    width?: number
}

const DeleteButtonOverlay = forwardRef<HTMLButtonElement, Props>(({
    onClick,
    width = 25,
    ...otherProps
}, ref) => {

    return (
        <Button
            className="delete-btn-overlay"
            ref={ref}
            color="danger"
            onClick={onClick}
            style={{
                width,
                height: width
            }}
            {...otherProps}
        >
            <Icon
                name="xmark"
                size={width*0.6}
            />
        </Button>
    )
})

export { DeleteButtonOverlay }
